/**
 * Timers overlay "Last frame" is the previous on-air frame's scheduled duration.
 * Apply it only after the new frame's elapsed clock has moved past 0 so loop-wrap
 * (e.g. 23s video → 1s image) does not briefly look like soft-stuck
 * (`Frame 0:00 / 0:01` + `Last frame 0:23`).
 *
 * Rapid A→B→C before B's elapsed advances: keep the latest pending (B's duration) —
 * C's previous on-air frame is B, not A.
 */
export function resolveTimersLastFrameDurationMs(input: {
  committedLastFrameDurationMs: number
  pendingLastFrameDurationMs: number | null
  frameElapsedMs: number
}): {
  lastFrameDurationMs: number
  pendingLastFrameDurationMs: number | null
} {
  if (input.pendingLastFrameDurationMs != null && input.frameElapsedMs > 0) {
    return {
      lastFrameDurationMs: input.pendingLastFrameDurationMs,
      pendingLastFrameDurationMs: null
    }
  }
  return {
    lastFrameDurationMs: input.committedLastFrameDurationMs,
    pendingLastFrameDurationMs: input.pendingLastFrameDurationMs
  }
}

/**
 * On visible-frame change: stash the outgoing frame's scheduled duration as pending and
 * clear the displayed Last frame until elapsed advances (see {@link resolveTimersLastFrameDurationMs}).
 */
export function stampTimersLastFrameOnTransition(input: {
  outgoingFrameDurationMs: number
}): {
  committedLastFrameDurationMs: number
  pendingLastFrameDurationMs: number
} {
  return {
    committedLastFrameDurationMs: 0,
    pendingLastFrameDurationMs: input.outgoingFrameDurationMs
  }
}
